import React from 'react'

const CopyrightPage = () => {
  return (
    <div className='md:pt-[140px] pt-[100px] md:px-[100px] px-4'>
      <h2 className="md:text-3xl text-xl font-bold md:mb-6 mb-2">
        Copyright/Disclaimer for Rehovot resources inc
      </h2>
      <p className="text-sm">
        If you require any more information or have any questions about our site's disclaimer, please feel free to contact us by email at <span className="font-bold">info@rehovotresourcesinc.com</span>  
        <br /> <br />
        Disclaimers for Rehovot resources inc 
        <br /> 
        All the information on this website - www.rehovotresourcesinc.com - is published in good faith and for general information purpose only. Rehovot resources inc does not make any warranties about the completeness, reliability and accuracy of this information. Any action you take upon the information you find on this website (Rehovot resources inc), is strictly at your own risk. Rehovot resources inc will not be liable for any losses and/or damages in connection with the use of our website. 
        <br /><br />
        From our website, you can visit other websites by following hyperlinks to such external sites. While we strive to provide only quality links to useful and ethical websites, we have no control over the content and nature of these sites. These links to other websites do not imply a recommendation for all the content found on these sites. Site owners and content may change without notice and may occur before we have the opportunity to remove a link which may have gone 'bad'.
        <br /><br />
        Please be also aware that when you leave our website, other sites may have different privacy policies and terms which are beyond our control. Please be sure to check the Privacy Policies of these sites as well as their "Terms of Service" before engaging in any business or uploading any information.
        <br /><br /> 
        <span className="font-bold">Consent</span>
        <br /> 
        By using our website, you hereby consent to our disclaimer and agree to its terms.
        <br /><br />
        <span className="font-bold">Update</span>
        <br />
        Should we update, amend or make any changes to this document, those changes will be prominently posted here.
      </p>
    </div>
  )
}

export default CopyrightPage